import { useLocation, useNavigate } from 'react-router-dom'
import useCurrentAppType from './useCurrentAppType'
import { all, equals, includes, not } from 'ramda'

const useHandlePublicRoutes = () => {
  const { isWellpower } = useCurrentAppType()
  const navigate = useNavigate()
  const pathname = useLocation()

  if (all(equals(true))([includes('/public', pathname), not(isWellpower)])) {
    navigate('/')
  }
}

export default useHandlePublicRoutes
